import script from "./PostList.vue?vue&type=script&setup=true&lang=js"
export * from "./PostList.vue?vue&type=script&setup=true&lang=js"

import "./PostList.vue?vue&type=style&index=0&id=e5d11d62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5d11d62"]])

export default __exports__